import React from 'react';
import './index.less';
import cN from 'classnames';

interface IProps {
  text: string;
  icon?: React.ReactNode;
}

const VerifiedSupplierPill = ({ text, icon }: IProps) => {
  return (
    <div className={cN('verified-supplier-pill', { 'custom-icon-verified-supplier-pill': icon })} data-text={text}>
      {icon}
    </div>
  );
};

export default VerifiedSupplierPill;
